import { render, staticRenderFns } from "./ItemSales2.vue?vue&type=template&id=3e05b2f5&"
import script from "./ItemSales2.vue?vue&type=script&lang=js&"
export * from "./ItemSales2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports